import React, { useContext } from 'react';
import { IMediaSettings } from 'types';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../../customerFullInfoState/customerFullInfoContext';
import MediaGroup from './components/MediaGroup';
import classNames from 'classnames';
import style from './MediaFields.module.scss';

interface IMediaFields {
	data: IMediaSettings;
}

const MediaFields: React.FC<IMediaFields> = ({ data }) => {
	const { selectedStyleLanguage } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const containerClasses = classNames(style.container, {
		[style.visible]: data.languageId === selectedStyleLanguage,
	});

	return (
		<div className={containerClasses}>
			{data.groups.map((el) => (
				<MediaGroup data={el} languageId={data.languageId} key={el.id} />
			))}
		</div>
	);
};

export default MediaFields;
